export default __webpack_public_path__ + "static/media/3.939ea18b.svg";